import { type RouteConfig } from 'vue-router'

/**
 * Creates a list of Device routes under a specific scope
 * @param {string} scope location or brand
 * @returns {object[]} a list of routes
 */
export const getDevicesRoutes = (
  scope: 'brand' | 'location'
): RouteConfig[] => [
  {
    children: [
      {
        component: async () => import('@/views/BrandView/DevicesView.vue'),
        meta: {
          isLocationPage: true,
        },
        name: `${scope}.devices.settings`,
        path: 'settings',
        props: {
          activeTab: `${scope}.devices.settings`,
          scope,
        },
      },
    ],
    component: {
      name: 'DevicesRouterView',
      // eslint-disable-next-line xss/no-mixed-html
      template: '<router-view></router-view>',
    },
    meta: {
      isLocationPage: true,
      scopes: ['devices:read'],
      title: 'restaurant.devices',
    },
    name: `${scope}.devices`,
    path: 'devices',
    props: { scope },
    redirect: { name: `${scope}.devices.settings` },
  },
]
